(() => {































































































































































































































































  const root = document.body;































































































































































































































































  if (!root.classList.contains('aera-goldseal-page')) return;































































































































































































































































  const form = document.getElementById('aera-goldseal-product-form');































































































































































































































































  const mount = document.querySelector('.aera-goldseal-kaching-mount');































































































































































































































































  const primary = document.getElementById('aera-goldseal-single-buy');

  window.AeraGoldsealCartURL = path => {

    const url=new URL((window.Shopify?.routes?.root || '/')+path,location.origin);

    const country=window.Shopify?.country;

    if(country)url.searchParams.set('country',country==='VA'?'US':country);

    return url.pathname+url.search;

  };





  const redirectingFromVA = window.Shopify?.country === 'VA';



  if (redirectingFromVA) {



    const localization=document.createElement('form');



    localization.method='post';localization.action='/localization';localization.hidden=true;



    for(const [name,value] of Object.entries({form_type:'localization',_method:'put',country_code:'US',return_to:location.pathname+location.search,utf8:'✓'})){



      const input=document.createElement('input');input.type='hidden';input.name=name;input.value=value;localization.append(input);



    }



    document.body.append(localization);



    localization.submit();



  }



  let busy = false;







  const diagnosticMode = new URLSearchParams(location.search).get('aera-debug') === '1';







  let lastCartDiagnostic;







  function showCartDiagnostic(record) {







    lastCartDiagnostic = record;







    if (!diagnosticMode) return;







    let box = document.getElementById('aera-cart-diagnostic');







    if (!box) {







      box = document.createElement('div');box.id='aera-cart-diagnostic';







      box.style.cssText='background:#fff8e8;border:1px solid #d6bd7f;border-radius:8px;padding:14px;margin:12px 0;color:#15283c;font:12px/1.5 Arial,sans-serif;';







      const label=document.createElement('strong');label.textContent='Cart diagnostic — send these details to support';







      const pre=document.createElement('pre');pre.style.cssText='white-space:pre-wrap;overflow-wrap:anywhere;font:11px/1.5 monospace;max-height:280px;overflow:auto';







      const copy=document.createElement('button');copy.type='button';copy.textContent='Copy diagnostic details';copy.style.cssText='background:#315d3e;color:white;border:0;border-radius:5px;padding:10px;cursor:pointer';







      copy.onclick=async()=>{try{await navigator.clipboard.writeText(JSON.stringify(lastCartDiagnostic,null,2));copy.textContent='Copied';}catch(_){copy.textContent='Please screenshot the details above';}};







      box.append(label,pre,copy);form.append(box);







    }







    box.querySelector('pre').textContent=JSON.stringify(record,null,2);







  }































































































































































































































































  function bundleActive() {































































































































































































































































    return Boolean(mount && [...mount.querySelectorAll('input,button,[role="radio"],select')].some(el => el.getClientRects().length));































































































































































































































































  }































































































































































































































































  async function addItem() {































































































































































































































































    if (!form || busy) return;



    if (redirectingFromVA) return;



    busy = true;































































































































































































































































    const error = form.querySelector('[role="alert"]');































































































































































































































































    error.hidden = true;































































































































































































































































    document.querySelectorAll('[data-aera-goldseal-buy]').forEach(el => el.setAttribute('aria-disabled','true'));































































































































































































































































    try {































































































































































































































































      const body = new FormData(form);







      showCartDiagnostic({time:new Date().toISOString(),country:window.Shopify?.country,currency:window.Shopify?.currency?.active,cartEndpoint:window.AeraGoldsealCartURL('cart/add.js'),localizationCookie:document.cookie.split('; ').find(x=>x.startsWith('localization='))?.split('=')[1]||null,variant:body.get('id'),quantity:body.get('quantity'),status:'sending'});































































































































































































































































      for (const [key,value] of body.entries()) {































































































































































































































































        if (key.includes('__kaching_bundles') && typeof value === 'string' && !value.trim().startsWith('{')) {































































































































































































































































          try { const decoded = atob(value); JSON.parse(decoded); body.set(key,decoded); } catch (_) {}































































































































































































































































        }































































































































































































































































      }































































































































































































































































      const res = await fetch(window.AeraGoldsealCartURL('cart/add.js'), {method:'POST', headers:{Accept:'application/json'}, body});































































































































































































































































      const data = await res.json();







      showCartDiagnostic({...lastCartDiagnostic,status:res.status,requestId:res.headers.get('x-request-id'),message:res.ok?'Added successfully':(data.description||data.message||'Unknown error')});































































































































































































































































      if (!res.ok) throw new Error(data.description || 'Unable to add this item. Please try again.');































































































































































































































































      await window.AeraGoldsealCart.open();































































































































































































































































      busy = false;































































































































































































































































      document.querySelectorAll('[data-aera-goldseal-buy]').forEach(el => el.removeAttribute('aria-disabled'));































































































































































































































































    } catch (e) {































































































































































































































































      if(lastCartDiagnostic?.status==='sending')showCartDiagnostic({...lastCartDiagnostic,status:'network error',message:e.message});







      error.textContent = e.message;































































































































































































































































      error.hidden = false;































































































































































































































































      error.scrollIntoView({behavior:'smooth',block:'center'});































































































































































































































































      busy = false;































































































































































































































































      document.querySelectorAll('[data-aera-goldseal-buy]').forEach(el => el.removeAttribute('aria-disabled'));































































































































































































































































    }































































































































































































































































  }































































































































































































































































  if (form) form.addEventListener('submit', e => { e.preventDefault(); addItem(); });































































































































































































































































  root.addEventListener('click', e => {































































































































































































































































    const buy = e.target.closest('[data-aera-goldseal-buy]');































































































































































































































































    if (buy && buy !== primary) {































































































































































































































































      e.preventDefault();































































































































































































































































      e.stopImmediatePropagation();































































































































































































































































      const target = document.querySelector('.kaching-bundles__block') || mount || document.getElementById('aera-goldseal-purchase');































































































































































































































































      target?.scrollIntoView({behavior: 'smooth', block: 'start'});































































































































































































































































      return;































































































































































































































































    }































































































































































































































































    if (buy) { e.preventDefault(); e.stopImmediatePropagation(); addItem(); }































































































































































































































































    const visit = e.target.closest('[data-aera-goldseal-visit]');































































































































































































































































    if (visit) window.location.assign(visit.dataset.aeraGoldsealVisit);































































































































































































































































  }, true);































































































































































































































































  if (primary) primary.addEventListener('keydown', e => { if (e.key === ' ') {e.preventDefault();addItem();} });































































































































































































































































  if (mount) {































































































































































































































































    const update = () => mount.dataset.active = String(bundleActive());































































































































































































































































    new MutationObserver(update).observe(mount, {childList:true, subtree:true, attributes:true, attributeFilter:['class','style','hidden']});































































































































































































































































    update();































































































































































































































































  }































































































































































































































































  document.addEventListener('keydown', e => {































































































































































































































































    if (e.key === 'Escape') document.getElementById('gs-adv-modal')?.classList.remove('open');































































































































































































































































  });































































































































































































































































  const animation = document.getElementById('aera-goldseal-brain-animation');































































































































































































































































  const parts = document.getElementById('aera-goldseal-brain-parts');































































































































































































































































  if (animation && parts) {































































































































































































































































    const urls = JSON.parse(parts.textContent);































































































































































































































































    const buffers = new Array(urls.length);































































































































































































































































    let next = 0;































































































































































































































































    const worker = async () => {































































































































































































































































      while (next < urls.length) {































































































































































































































































        const index = next++;































































































































































































































































        const response = await fetch(urls[index]);































































































































































































































































        if (!response.ok) throw new Error('Animation asset unavailable');































































































































































































































































        const binary = atob(await response.text());































































































































































































































































        const bytes = new Uint8Array(binary.length);































































































































































































































































        for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);































































































































































































































































        buffers[index] = bytes;































































































































































































































































      }































































































































































































































































    };































































































































































































































































    Promise.all(Array.from({length:4}, worker)).then(() => {































































































































































































































































      const url = URL.createObjectURL(new Blob(buffers, {type:'image/gif'}));































































































































































































































































      animation.src = url;































































































































































































































































      animation.dataset.animationReady = 'true';































































































































































































































































      window.addEventListener('pagehide', () => URL.revokeObjectURL(url), {once:true});































































































































































































































































    }).catch(() => { animation.dataset.animationReady = 'false'; });































































































































































































































































  }































































































































































































































































})();































































































































































































































































































































































































































































































































(() => {































































































































































































































































  if (!document.body.classList.contains('aera-goldseal-page')) return;































































































































































































































































  const dialog = document.createElement('dialog');































































































































































































































































  dialog.className = 'ags-cart';































































































































































































































































  dialog.setAttribute('aria-labelledby','ags-cart-title');































































































































































































































































  dialog.innerHTML = `<header class="ags-cart-head"><div><span class="ags-eyebrow">GOLDSEAL</span><h2 id="ags-cart-title">Your cart <span class="ags-count"></span></h2></div><button type="button" class="ags-close" aria-label="Close cart">×</button></header><div class="ags-cart-content"><div class="ags-cart-status" role="status" aria-live="polite"></div><div class="ags-items"></div><div class="ags-guarantee"><span class="ags-shield" aria-hidden="true"><svg width="22" height="26" viewBox="0 0 24 28" fill="none"><path d="M12 2 21 5v8c0 6-9 12-9 12S3 19 3 13V5l9-3Z" stroke="currentColor" stroke-width="1.5"/><path d="m7.5 13 3 3 6-7" stroke="currentColor" stroke-width="1.5"/></svg></span><div><strong>Your 30-day peace of mind</strong><p>Try it for 30 days. If you don’t feel a difference, request a full refund.</p><a href="/pages/aera-goldseal-refund-policy">Read our money-back guarantee</a></div></div><div class="ags-trust"><span>✓ 3rd-party tested</span><span>✓ Secure Shopify checkout</span></div><div class="ags-cart-error" role="alert" hidden></div></div><footer class="ags-cart-foot"><div class="ags-savings" hidden></div><div class="ags-subtotal"><span>Subtotal</span><strong></strong></div><div class="ags-free-shipping" hidden><span><svg aria-hidden="true" width="19" height="19" viewBox="0 0 24 24" fill="none"><path d="M3 5h11v12H3V5Zm11 5h4l3 4v3h-7v-7Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="7" cy="18" r="2" fill="white" stroke="currentColor" stroke-width="1.5"/><circle cx="18" cy="18" r="2" fill="white" stroke="currentColor" stroke-width="1.5"/></svg>Shipping</span><strong>FREE</strong></div><p class="ags-shipping">Shipping and taxes calculated at checkout.</p><a class="ags-checkout" href="/checkout">Secure checkout <span aria-hidden="true">→</span></a><p class="ags-payment">Encrypted payment &middot; Secure checkout<br>Available payment methods shown at checkout</p><button class="ags-continue" type="button">Continue shopping</button><nav><a href="/pages/aera-goldseal-shipping-policy">Shipping</a><a href="/pages/aera-goldseal-refund-policy">Returns</a><a href="/pages/contact">Need help?</a></nav></footer>`;































































































































































































































































  document.body.append(dialog);

  dialog.querySelector('.ags-checkout').href=window.AeraGoldsealCartURL('checkout');
  dialog.querySelector('.ags-checkout').addEventListener('click',function(event){
    if(locked||event.defaultPrevented)return;
    try{
      if(lastCartGoldsealOnly){
        localStorage.setItem('aera-goldseal-checkout-return',JSON.stringify({version:1,product:8521829056559,created:Date.now()}));
      }else{
        localStorage.removeItem('aera-goldseal-checkout-return');
      }
    }catch(_){}
  });
































































































































































































































































  let currency = 'USD', locked = false, previousFocus, lastCartGoldsealOnly = false;































































































































































































































































  const money = cents => new Intl.NumberFormat('en-US',{style:'currency',currency}).format(cents/100);































































































































































































































































  const escape = value => String(value).replace(/[&<>"']/g, char=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));































































































































































































































































  function close() { dialog.close(); }































































































































































































































































  dialog.querySelector('.ags-close').onclick=close;































































































































































































































































  dialog.querySelector('.ags-continue').onclick=close;































































































































































































































































  dialog.addEventListener('click',e=>{if(e.target===dialog)close();});































































































































































































































































  dialog.addEventListener('close',()=>{document.body.style.overflow='';previousFocus?.focus({preventScroll:true});});































































































































































































































































  function draw(cart) {































































































































































































































































    currency=cart.currency||'USD';































































































































    dialog.classList.toggle('ags-is-empty',!cart.item_count);































    const goldsealOnly=cart.item_count>0&&cart.items.every(item=>item.product_id===8521829056559);
    lastCartGoldsealOnly=goldsealOnly;































    dialog.querySelector('.ags-free-shipping').hidden=!goldsealOnly;































    dialog.querySelector('.ags-shipping').textContent=goldsealOnly?'Free shipping included. Taxes calculated at checkout.':'Shipping and taxes calculated at checkout.';































































































































    dialog.querySelector('.ags-cart-foot').hidden=!cart.item_count;































































































































    dialog.querySelector('.ags-trust').hidden=!cart.item_count;































































































































































































































































    dialog.querySelector('.ags-count').textContent=cart.item_count?`(${cart.item_count})`:'';































































































































































































































































    const groups = new Map();































































































































































































































































    cart.items.forEach(item=>{































































































































































































































































      const key=String(item.product_id);































































































































































































































































      if(!groups.has(key))groups.set(key,{items:[],quantity:0,total:0,original:0,item});































































































































































































































































      const group=groups.get(key);group.items.push(item);group.quantity+=item.quantity;group.total+=item.final_line_price;group.original+=item.original_line_price;































































































































































































































































    });































































































































































































































































    dialog.querySelector('.ags-items').innerHTML = [...groups.values()].map(g=>{































































































































































































































































      const isGoldseal=g.item.product_id===8521829056559;































































































































































































































































      const offer=isGoldseal?(g.quantity===3?'Buy 2, Get 1 FREE':g.quantity===5?'Buy 3, Get 2 FREE':''):'';































































































































































































































































      const image=g.item.featured_image?.url||g.item.image;































































































































































































































































      return `<article class="ags-item" data-product="${g.item.product_id}"><div class="ags-item-top">${image?`<img src="${escape(image)}" alt="${escape(g.item.product_title)}" width="84" height="100">`:''}<div><span class="ags-item-brand">${isGoldseal?'GOLDSEAL':''}</span><h3>${escape(g.item.product_title)}</h3>${offer?`<span class="ags-offer">${offer}</span>`:''}<p>${g.quantity} ${isGoldseal?'bottle'+(g.quantity===1?'':'s'):'item'+(g.quantity===1?'':'s')}${isGoldseal?' · '+g.quantity*30+'-day supply':''}</p><div class="ags-line-price"><strong>${money(g.total)}</strong>${g.original>g.total?`<s>${money(g.original)}</s>`:''}</div></div></div><div class="ags-item-actions">${isGoldseal?'<button type="button" data-change-bundle>Change bundle</button>':`<span>Quantity: ${g.quantity}</span>`}<button type="button" data-remove>Remove</button></div></article>`;































































































































































































































































     }).join('') || `<div class="ags-empty"><div class="ags-empty-icon" aria-hidden="true"><svg width="48" height="48" viewBox="0 0 48 48" fill="none"><path d="M12 17h24l2 24H10l2-24Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M18 19v-7a6 6 0 0 1 12 0v7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></div><span class="ags-empty-kicker">MAGNESIUM COMPLETE</span><h3>Your cart is empty</h3><p>Choose your supply and take the first step toward your daily routine.</p><button class="ags-empty-shop" type="button" data-change-bundle>Choose my supply <span aria-hidden="true">→</span></button><div class="ags-empty-assurance"><svg aria-hidden="true" width="16" height="18" viewBox="0 0 16 18" fill="none"><path d="M8 1 14 3.5V9c0 4-6 7.5-6 7.5S2 13 2 9V3.5L8 1Z" stroke="currentColor" stroke-width="1.3"/><path d="m5 8.5 2 2 4-4" stroke="currentColor" stroke-width="1.3"/></svg><span>30-day money-back guarantee</span></div><a class="ags-empty-help" href="/pages/contact">Have a question? We’re here to help.</a></div>`;































































































































































































































































    dialog.querySelector('.ags-subtotal strong').textContent=money(cart.total_price);































































































































































































































































    const savings=Math.max(0,cart.original_total_price-cart.total_price);































































































































































































































































    const savingsEl=dialog.querySelector('.ags-savings');savingsEl.hidden=!savings;savingsEl.textContent=`Your savings ${money(savings)}`;































































































































































































































































    dialog.querySelector('.ags-checkout').hidden=!cart.item_count;































































































































































































































































    dialog.querySelector('.ags-guarantee').hidden=!cart.items.some(x=>x.product_id===8521829056559);































































































































































































































































  }































































































































































































































































  async function refresh() {































































































































































































































































    const response=await fetch(window.AeraGoldsealCartURL('cart.js'),{headers:{Accept:'application/json'},cache:'no-store'});































































































































































































































































    if(!response.ok)throw new Error('Unable to load your cart. Please try again.');































































































































































































































































    const cart=await response.json();draw(cart);return cart;































































































































































































































































  }































































































































































































































































  function cartIsEmpty(){return dialog.classList.contains('ags-is-empty');}































































































































  async function open() {































































































































































































































































    previousFocus=document.activeElement;































































































































































































































































    await refresh();































































































































































































































































    if(!dialog.open)dialog.showModal();































































































































































































































































    document.body.style.overflow='hidden';































































































































































































































































    dialog.querySelector(cartIsEmpty()?'.ags-empty-shop':'.ags-close')?.focus({preventScroll:true});































































































































































































































































  }































































































































































































































































  async function change(productId,quantity) {































































































































































































































































    if(locked)return;locked=true;































































































































































































































































    const error=dialog.querySelector('.ags-cart-error');error.hidden=true;































































































































































































































































    dialog.querySelector('.ags-cart-status').textContent='Updating your cart…';































































































































































































































































    dialog.querySelectorAll('button,select,.ags-checkout').forEach(x=>{x.disabled=true;x.setAttribute('aria-disabled','true');});































































































































































































































































    try {































































































































































































































































      const res=await fetch(window.AeraGoldsealCartURL('cart.js'));const cart=await res.json();































































































































































































































































      const lines=cart.items.filter(x=>x.product_id===productId);































































































































































































































































      const updates={};lines.forEach(x=>updates[x.key]=0);































































































































































































































































      const response=await fetch(window.AeraGoldsealCartURL('cart/update.js'),{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates})});































































































































































































































































      if(!response.ok)throw new Error('Unable to remove this item. Please try again.');































































































































































































































































      await refresh();































































































































































































































































    } catch(e){error.textContent=e.message;error.hidden=false;await refresh().catch(()=>{});}































































































































































































































































    finally{locked=false;dialog.querySelector('.ags-cart-status').textContent='';dialog.querySelectorAll('button,select,.ags-checkout').forEach(x=>{x.disabled=false;x.removeAttribute('aria-disabled');});}































































































































































































































































  }































































































































































































































































  dialog.addEventListener('click',e=>{if(e.target.closest('[data-change-bundle]')){close();const target=document.querySelector('.kaching-bundles__block');if(target)target.scrollIntoView({behavior:'smooth',block:'center'});else location.assign('/products/aera-goldseal-magnesium-complete');}});































































































































































































































































  dialog.addEventListener('click',e=>{if(e.target.closest('[data-remove]'))change(Number(e.target.closest('[data-product]').dataset.product),0);if(locked&&e.target.closest('.ags-checkout'))e.preventDefault();});































































































































































































































































  window.AeraGoldsealCart={open,refresh};































































































































































































































































  const reopen=document.createElement('button');reopen.className='ags-cart-reopen';reopen.textContent='Your cart';reopen.setAttribute('aria-label','Open your cart');reopen.onclick=()=>open();if(document.getElementById('aera-goldseal-product-form'))document.body.append(reopen);































































































































































































































































})();































































































































































































































































































































(() => {































































  if (!document.body.classList.contains('aera-goldseal-page')) return;































































  const pages = new Map([































































    ['/pages/tracking-order','Track Order'],































































    ['/policies/privacy-policy','Privacy Policy'],































































    ['/pages/aera-goldseal-terms-of-service','Terms of Service'],































































    ['/pages/aera-goldseal-refund-policy','Refund Policy'],































































    ['/pages/aera-goldseal-shipping-policy','Shipping Policy'],































































    ['/pages/contact','Contact Us']































































  ]);































































  const modal=document.createElement('dialog');































































  modal.className='ags-info';modal.setAttribute('aria-labelledby','ags-info-title');































































  modal.innerHTML=`<div class="ags-info-head"><div><span class="ags-eyebrow">GOLDSEAL</span><h2 id="ags-info-title"></h2></div><button class="ags-info-close" type="button" aria-label="Close information">&times;</button></div><div class="ags-info-loading" role="status">Loading…</div><iframe class="ags-info-frame" title="Store information" hidden></iframe><div class="ags-info-bottom"><span>Here to help, every step of the way.</span><a class="ags-info-original" target="_blank" rel="noopener">Open full page ↗</a></div>`;































































  document.body.append(modal);































































  const frame=modal.querySelector('iframe'),loading=modal.querySelector('.ags-info-loading');































































  let previousFocus,oldOverflow;































































  modal.querySelector('.ags-info-close').onclick=()=>modal.close();































































  modal.addEventListener('click',e=>{if(e.target===modal)modal.close();});































































  modal.addEventListener('close',()=>{document.body.style.overflow=oldOverflow;previousFocus?.focus({preventScroll:true});});































































  function prepareFrame(){































































    try{































































      const doc=frame.contentDocument;































































      if(!doc||doc.readyState==='loading')return;































































      const main=doc.querySelector('main,.shopify-policy__container');































































      if(!main)return;































































      if(main.dataset.infoPath!==currentInfoPath)return;































































      let node=main;































































      while(node.parentElement&&node!==doc.body){































































        [...node.parentElement.children].forEach(x=>{if(x!==node&&!['SCRIPT','STYLE','LINK'].includes(x.tagName))x.style.setProperty('display','none','important');});































































        node=node.parentElement;































































      }































































      const style=doc.createElement('style');































































      style.textContent=`main *{font-family:'DM Sans',Arial,sans-serif!important;letter-spacing:normal!important}.rte{margin:0!important;padding:0!important}.rte>:first-child{margin-top:0!important}.rte p{margin:0 0 16px!important}.rte h2,.rte h3{margin:24px 0 12px!important;font-weight:600!important}.rte li{margin-bottom:8px!important}html,body{background:#fff!important;color:#11243b!important;margin:0!important;padding:0!important;overflow:auto!important;font-family:'DM Sans',Arial,sans-serif!important;font-size:14px!important}main{padding:0!important;margin:0!important;max-width:none!important;min-height:0!important}.main-content__inner-container,.shopify-policy__container,.page-width,.aec-shell{max-width:none!important;width:100%!important;margin:0!important;padding:24px!important;box-sizing:border-box!important}.shopify-policy__container{padding:0!important}.main-page-title{display:none!important}.main-content__inner-container{padding:0!important}.shopify-policy__container{padding:24px!important}.shopify-policy__title,.aec-heading,.aeg-track-heading,.aeg-track-visual{display:none!important}.rte,.shopify-policy__body{font-size:14px!important;line-height:1.8!important;color:#42544b!important}.rte h1,.rte h2,.rte h3,h2,h3{color:#11243b!important;line-height:1.35!important;letter-spacing:0!important}.rte h2,h2{font-size:20px!important}.rte h3,h3{font-size:17px!important}.rte p,.rte li{line-height:1.8!important}.rte a,a{color:#357747!important;text-underline-offset:3px}.aec-contact-grid,.aeg-track-grid{display:flex!important;flex-direction:column!important;gap:24px!important}.aec-support,.aec-form,.aeg-track-card,.aeg-track-help,.aeg-track-notes{background:#f7faf4!important;border:1px solid #dce8d8!important;border-radius:12px!important;padding:20px!important;box-shadow:none!important}.aec-support{order:2!important}.aec-form{order:1!important}.aec-eyebrow,.aeg-track-eyebrow{color:#92763e!important;font-size:10px!important;letter-spacing:1.3px!important}input:not([type=hidden]),textarea{border:1px solid #d7e2d3!important;border-radius:7px!important;background:white!important;color:#11243b!important;font-size:14px!important}button[type=submit],.aeg-track-submit{background:linear-gradient(#70c672,#4eb465)!important;color:white!important;border:0!important;border-radius:8px!important;box-shadow:none!important} .aeg-track-notes{margin-top:20px!important}footer,header,.shopify-section-group-header-group,.shopify-section-group-footer-group,.announcement-bar,cart-drawer,.shopify-section:has(>.newsletter){display:none!important}@media(max-width:480px){.main-content__inner-container,.page-width,.aec-shell{padding:18px!important}.aec-support,.aec-form,.aeg-track-card,.aeg-track-help,.aeg-track-notes{padding:16px!important}}`;































































      doc.head.append(style);































































      const contact=doc.querySelector('.aec-heading');































































      if(contact){const eyebrow=doc.querySelector('.aec-eyebrow');if(eyebrow)eyebrow.textContent='GOLDSEAL SUPPORT';}































































      frame.hidden=false;loading.hidden=true;clearInterval(framePoll);































































      doc.querySelectorAll('form').forEach(f=>f.target='_top');































































      doc.querySelectorAll('a').forEach(a=>{a.target='_blank';a.rel='noopener';});































































    }catch(_){loading.textContent='Please use “Open full page” below to view this information.';frame.hidden=true;}































































  }































































  frame.addEventListener('load',prepareFrame);































































  let framePoll,loadVersion=0,currentInfoPath='';































































  async function loadContent(path){































































    const version=++loadVersion;currentInfoPath=path;































































    try{































































      const response=await fetch(path,{headers:{Accept:'text/html'}});































































      if(!response.ok)throw new Error('Unable to load');































































      const html=await response.text();if(version!==loadVersion)return;































































      const source=new DOMParser().parseFromString(html,'text/html');































































      const main=source.querySelector('main,.shopify-policy__container');































































      if(!main)throw new Error('Content unavailable');































































      main.dataset.infoPath=path;































































      main.querySelectorAll('script').forEach(script=>{if(!script.src.includes('/aeg-tracking.js'))script.remove();});































































      const styles=[...source.head.querySelectorAll('link[rel="stylesheet"],style')].map(x=>x.outerHTML).join('');































































      frame.srcdoc='<!doctype html><html lang="en"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><base href="'+location.origin+'/">'+styles+'</head><body>'+main.outerHTML+'</body></html>';































































    }catch(_){clearInterval(framePoll);loading.textContent='Unable to load this page. Please use ?Open full page? below.';}































































  }































































  document.addEventListener('click',e=>{































































    const link=e.target.closest('a[href]');if(!link||e.ctrlKey||e.metaKey||e.shiftKey||e.altKey)return;































































    const url=new URL(link.href,location.origin);const title=url.origin===location.origin&&pages.get(url.pathname.replace(/\/$/,''));































































    if(!title||link.classList.contains('ags-info-original'))return;































































    e.preventDefault();e.stopImmediatePropagation();































































    previousFocus=document.activeElement;oldOverflow=document.body.style.overflow;































































    modal.querySelector('h2').textContent=title;frame.title=title;































































    modal.querySelector('.ags-info-original').href=url.pathname;































































    loading.textContent='Loading…';loading.hidden=false;frame.hidden=true;loadContent(url.pathname);clearInterval(framePoll);framePoll=setInterval(prepareFrame,200);































































    modal.showModal();document.body.style.overflow='hidden';modal.querySelector('button').focus({preventScroll:true});































































  },true);































































})();
































































(() => {
 const mount=document.body.dataset.aeraGoldsealPage==='pdp'?document.body:null;
 if(!mount)return;
 function syncUnitPrices(){
  mount.querySelectorAll('.kaching-bundles__bar').forEach(bar=>{
   const text=bar.textContent;
   const bottles=text.match(/(\d+) bottles?/i);
   if(!bottles)return;
   const quantity=Number(bottles[1]);
   const amount=quantity===1?39.95:quantity===3?79.90:quantity===6?119.85:null;
   if(amount===null)return;
   const price=(Math.round(amount*100/quantity)/100).toFixed(2);
   const walker=document.createTreeWalker(bar,NodeFilter.SHOW_TEXT);
   let node;while(node=walker.nextNode()){
    const value=node.nodeValue.replace(/\$[\d,.]+\/bottle/g,'$'+price+'/bottle');
    if(value!==node.nodeValue)node.nodeValue=value;
   }
  });
 }
 new MutationObserver(syncUnitPrices).observe(mount,{childList:true,subtree:true,characterData:true});
 syncUnitPrices();
})();
